import React from 'react'
import styled from '@emotion/styled'

import themeVars from 'ui_theme/site/globals/site.variables'
import { Flex, SUI, Header, Icon } from 'shared/ui'
import ListenToKeyboard from 'components/ListenToKeyboard'

import Actions from './Actions'
import Conversation from './Conversation'
import ConversationsList from './ConversationsList'
import Other from './Other'
import ReplyNoteForm from './ReplyNoteForm'
import VersionNumber from './VersionNumber'

const HotkeysModalContainer = styled('div')`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${themeVars.massive};
  background-color: hsla(0, 0%, 100%, 0.96);
  overflow: auto;
  z-index: 1000000;
`

const ContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  & > * {
    flex-shrink: 0;
  }
`

const Title = styled(Header)`
  && {
    margin-bottom: ${props => props.theme.spacing['14']};
  }
`

const CloseButton = styled('div')`
  position: fixed;
  top: ${props => props.theme.spacing['7']};
  right: ${props => props.theme.spacing['10']};
`

const Columns = styled(Flex)`
  white-space: nowrap; // no items should span more than one line

  & > * {
    flex: 1 1 0;
  }

  & > * + * {
    margin-left: ${themeVars.massive};
  }
`

export default function HotkeysModal({ visible, close }) {
  if (!visible) return null

  return (
    <React.Fragment>
      <ListenToKeyboard onEscape={close} />
      <SUI>
        <HotkeysModalContainer>
          <ContentContainer>
            <Title size="medium">Keyboard shortcuts</Title>

            <Columns>
              <div>
                <ConversationsList />
                <Conversation />
                {false && <ReplyNoteForm />}
                <Other />
              </div>
              <div>
                <Actions />
              </div>
            </Columns>
          </ContentContainer>

          <VersionNumber />

          <CloseButton>
            <Icon name="close" size="large" onClick={close} />
          </CloseButton>
        </HotkeysModalContainer>
      </SUI>
    </React.Fragment>
  )
}
